module.exports = __webpack_public_path__ + "img/medal-outline.9fd1b034.svg";